module.exports = __webpack_public_path__ + "static/media/Home-TealWave1.4717b5dd.svg";